import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"align-items":"baseline","align-content":"space-between"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_SelectItem = _resolveComponent("SelectItem")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Accordion, null, {
      button: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("shared.search-and-filter")), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Search, {
            value: _ctx.search,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            onSearchChanged: _ctx.onSearchChange
          }, null, 8, ["value", "onSearchChanged"]),
          _createVNode(_component_SelectItem, {
            id: "coordinator",
            value: _ctx.selectedCoordinator.id,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCoordinator.id) = $event)),
            name: _ctx.selectedCoordinator.name,
            "onUpdate:name": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCoordinator.name) = $event)),
            onSelectionChanged: _ctx.onCoordinatorChange,
            options: _ctx.coordinators,
            placeholder: `- ${_ctx.$t('shared.choose')} -`,
            placeholderValue: "0",
            enableReset: true,
            label: _ctx.$t('shared.coordinator')
          }, null, 8, ["value", "name", "onSelectionChanged", "options", "placeholder", "label"])
        ])
      ]),
      _: 1
    }),
    _hoisted_2,
    _createVNode(_component_Table, {
      rows: _ctx.rows,
      sortColumn: _ctx.sortColumn,
      "onUpdate:sortColumn": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sortColumn) = $event)),
      ascending: _ctx.ascending,
      "onUpdate:ascending": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ascending) = $event)),
      stickyFirstColumn: "",
      showPagination: "",
      allowChangeRowPerPage: "",
      showNumRows: "",
      unsortableColumns: _ctx.unsortableColumns,
      pagingData: _ctx.pagingData,
      pageHeading: _ctx.pageHeading,
      useSpinner: true,
      isLoading: _ctx.isLoading,
      onPageNumberChanged: _ctx.onPageNumberChange,
      onSortChanged: _ctx.onSortChange,
      onPageSizeChanged: _ctx.onPageSizeChange
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: { name: 'AddStudent' },
          type: "button",
          class: "btn btn-sm btn-primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("shared.routes.add-student")), 1)
          ]),
          _: 1
        })
      ]),
      td: _withCtx((data) => [
        (data.col === 'coordinatorName')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("shared.coordinator")), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t(`person.${data.col}`)), 1))
      ]),
      default: _withCtx((data) => [
        (data.col === 'personalId')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: _ctx.navigateToDetailsUrl + data.row.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.val), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          : _createCommentVNode("", true),
        (data.col === 'grantedSupportDate')
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
              (data.val.isSameOrAfter(_ctx.today, 'day'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(data.val.format("YYYY-MM-DD")), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("student-list.expired")), 1))
            ]))
          : _createCommentVNode("", true),
        (
          data.col !== 'coordinatorName' &&
          data.col !== 'personalId' &&
          data.col !== 'grantedSupportDate'
        )
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(data.val), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["rows", "sortColumn", "ascending", "unsortableColumns", "pagingData", "pageHeading", "isLoading", "onPageNumberChanged", "onSortChanged", "onPageSizeChanged"])
  ], 64))
}